'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$12() {
  this.b5s = null;
  this.b5t = false;
}
export { $c_Lpresto_LoginPageView$$anon$12 as $c_Lpresto_LoginPageView$$anon$12 };
$p = $c_Lpresto_LoginPageView$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$12;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$12() {
}
export { $h_Lpresto_LoginPageView$$anon$12 as $h_Lpresto_LoginPageView$$anon$12 };
$h_Lpresto_LoginPageView$$anon$12.prototype = $p;
$p.P = (function() {
  if ((!this.b5t)) {
    this.b5s = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD()));
    this.b5t = true;
  }
  return this.b5s;
});
var $d_Lpresto_LoginPageView$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$12, "presto.LoginPageView$$anon$12", ({
  M4: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_LoginPageView$$anon$12 as $d_Lpresto_LoginPageView$$anon$12 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$12.js.map
